import React from 'react'
import SkillBoxProductDetail from '../feature/SkillBox/SkillBoxProductDetail'

const SkillBoxProductDetailPage = () => {
  return (
   <SkillBoxProductDetail/>
  )
}

export default SkillBoxProductDetailPage
